import { render, staticRenderFns } from "./taskGroup.vue?vue&type=template&id=4c94f6f4&scoped=true&"
import script from "./taskGroup.vue?vue&type=script&lang=js&"
export * from "./taskGroup.vue?vue&type=script&lang=js&"
import style0 from "./taskGroup.vue?vue&type=style&index=0&id=4c94f6f4&scoped=true&lang=css&"
import style1 from "./taskGroup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94f6f4",
  null
  
)

export default component.exports